"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDnDGridItem = useDnDGridItem;
const react_1 = require("react");
const DnDGrid_1 = require("./DnDGrid");
const DnDGridContext_1 = require("./DnDGridContext");
/** Provides props for a GridItem to be draggable */
function useDnDGridItem(props) {
    const { id, itemRef } = props;
    const { dragEl, onDragHandleKeyDown } = (0, DnDGridContext_1.useDnDGridContext)();
    const { dragItemProps, dragHandleProps } = (0, react_1.useMemo)(() => {
        function initDraggable() {
            if (itemRef.current) {
                dragEl.current = itemRef.current;
            }
        }
        return {
            dragItemProps: { [DnDGrid_1.gridItemIdKey]: id },
            dragHandleProps: {
                onMouseDown: initDraggable,
                onTouchStart: initDraggable,
                onKeyDown: (e) => {
                    initDraggable();
                    onDragHandleKeyDown(e);
                },
            },
        };
    }, 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dragEl, id, itemRef]);
    return { dragHandleProps, dragItemProps };
}
